import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnFM: CultureInfo = {
  name: 'en-FM',
  displayName: 'English (Micronesia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-FM',
  parent: CultureInfoEn
};
